import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center mb-4" }
const _hoisted_2 = {
  style: {"width":"160px"},
  class: "mx-2"
}
const _hoisted_3 = { class: "mx-2" }
const _hoisted_4 = { class: "mx-2" }
const _hoisted_5 = { class: "mb-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_school_service_edit_container = _resolveComponent("school-service-edit-container")!
  const _component_school_service_create_container = _resolveComponent("school-service-create-container")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_school_service_daily_contianer = _resolveComponent("school-service-daily-contianer")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_school_service_monthly_container = _resolveComponent("school-service-monthly-container")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_title, { value: "園提供サービス" }),
      _createVNode(_component_v_spacer),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_text_field, {
          "hide-details": "",
          density: "compact",
          variant: "outlined",
          type: "number",
          modelValue: _ctx.year,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
          modelModifiers: { number: true },
          suffix: "年度"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_school_service_edit_container)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_school_service_create_container)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event)),
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, { value: "daily" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("利用回数ごと", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_tab, { value: "monthly" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("固定月額・利用月額", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_window, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event)),
        class: "mt-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "daily" }, {
            default: _withCtx(() => [
              _createVNode(_component_school_service_daily_contianer)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "monthly" }, {
            default: _withCtx(() => [
              _createVNode(_component_school_service_monthly_container)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}